/**
 * Loading Spinner Component
 * Full-screen loading indicator
 */

import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface LoadingSpinnerProps {
  message?: string;
  fullScreen?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const sizeMap = {
  sm: 24,
  md: 48,
  lg: 64,
};

export function LoadingSpinner({ message, fullScreen = true, size = 'md' }: LoadingSpinnerProps) {
  const { t } = useTranslation();

  const content = (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap={2}>
      <CircularProgress size={sizeMap[size]} />
      <Typography variant="body1" color="text.secondary">
        {message || t('common.loading')}
      </Typography>
    </Box>
  );

  if (fullScreen) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'background.default',
          zIndex: 9999,
        }}
      >
        {content}
      </Box>
    );
  }

  return content;
}

export default LoadingSpinner;
